module.exports = __webpack_public_path__ + "img/like.03209ed.png";